import * as React from "react"
import { AppTableSeeker } from "@components"

import { activeDiffColumn, activeUsersColumn, countryColumn, dailyColumn, dashboardColumn, diffColumn, sectionColumn, totalDiffColumn, userColumn, customerColumn } from "./columns"
import { TABS_TOP } from "../../../@constants"
import {appliedCustomerIDs} from "../../../@signals";


export default function UserActivitiesTopTables({ title, label='Active Days', data, api, showActiveUsers=false, showActivePercentage=false, onDownload }) {
    return <AppTableSeeker
		data={data}
		title={title}
		columns={[
			...api === TABS_TOP.MARKETS ? countryColumn() : [],
			...api === TABS_TOP.USERS ? [userColumn(), ...countryColumn()] : [],
			...api === TABS_TOP.DASHBOARD ? [dashboardColumn(), sectionColumn()] : [],
			...appliedCustomerIDs.value.length !== 1 ? [customerColumn()] : [],
			...showActiveUsers ? [
				activeUsersColumn(),
				...showActivePercentage ? [totalDiffColumn()] : [],
				activeDiffColumn()
			] : [],
			dailyColumn(label),
			diffColumn()
		]}
		options={{
			onDownload: onDownload,
			tableBodyMaxHeight: '450px',
			sortOrder: api === TABS_TOP.DASHBOARD ?
				{ name: 'activeUsers', direction: 'desc'} :
				{ name: showActivePercentage ? 'totalDiff' : 'current', direction: 'desc' }
		}}
	/>
}